import React from 'react';
import styles from './ContactBtn.module.css';

const ContactBtn = ({ onClick }) => {
    const scrollToFooter = () => {
        const footerElement = document.getElementById('footer');
        if (footerElement) {
            footerElement.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <button 
            className={styles.contactBtn} 
            onClick={onClick || scrollToFooter}
        >
            <span className={styles.text}>Let's Talk</span>
            <span className={styles.icon}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
            </span>
        </button>
    );
};

export default ContactBtn;